import { render, staticRenderFns } from "./SpendComparison.vue?vue&type=template&id=5bd32805"
import script from "./SpendComparison.vue?vue&type=script&lang=js"
export * from "./SpendComparison.vue?vue&type=script&lang=js"
import style0 from "./SpendComparison.vue?vue&type=style&index=0&id=5bd32805&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports